export enum GedOngletEnum {
    ARCHIVE = 'ARCHIVE',
    PUBLIC = 'PUBLIC',
    PRIVE = 'PRIVE'
}
